<template>
  <div class="gw-comment v-centerer">
    <EditableLabel
      v-model="comment.text"
      :placeholder="$t('message.COMMENT_PLACEHOLDER')"
      use-tiptap-editor
      display-tiptap-menu
      display-tiptap-tasks
      @input="$emit('edit')"
    />

    <Badge
      :color="comment.files && comment.files.length > 0 ? SColors.mainTextColor : SColors.mediumGray"
      @click.stop.native="$emit('editPictures', $event)"
    >
      <span slot="badge">{{ comment.files.length }}</span>
      <div class="gw-comment__button generic-border generic-border--large-icon-button generic-border--gray-border">
        <Icon>{{ galleryMedium }}</Icon>
      </div>
    </Badge>

    <div
      class="gw-comment__button generic-border generic-border--large-icon-button generic-border--gray-border"
      @click="$emit('delete')"
    >
      <Icon>{{ deleteMedium }}</Icon>
    </div>
  </div>
</template>

<script>
// Components
import Badge from '@/components/badge.vue';
import EditableLabel from '@/components/editable-label.vue';
import Icon from '@/components/icon.vue';
// Utils
import { deleteMedium, galleryMedium } from '@/assets/icons';
import { SColors } from '@/utils/constants';

export default {

  name: 'GwComment',

  components: {
    Badge,
    EditableLabel,
    Icon,
  },

  props: {
    comment: {
      type: Object,
      required: true,
    },
    pbButton: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      SColors,
      deleteMedium,
      galleryMedium,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.gw-comment {
  display: flex;
  margin: 0px 0px 20px;

  .editable-label {
    flex: 1;
    min-width: 0px;
  }

  &__button {
    margin-left: 0.7rem;
  }
}
</style>
